import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TaskLogParams } from '@ml/tasks/types/classes';
import { Observable } from 'rxjs';
import { TaskLog } from '@ml/tasks/types/classes/task-log.class';
import { Params } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class LogsService {
  private readonly url = 'task-logs';

  constructor(private http: HttpClient) {}

  list(params: TaskLogParams): Observable<TaskLog[]> {
    return this.http.get<TaskLog[]>(this.url, { params: params as Params });
  }
}
